import React from 'react';

import graph from './graph';
import schema from './schema';
import uiSchema from './uiSchema';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { MuiFormBuilder } from 'components';
import { useMutation } from '@apollo/client';

const RefundToWalletForm = ({ formData, id, refetch }) => {
  const { userToken } = useSelector((state) => state.auth);

  const [formUpdate, { loading }] = useMutation(graph.createTransaction.query, {
    context: {
      serviceName: graph.createTransaction.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onSubmit = async ({ formData }) => {
    try {
      const { data } = await formUpdate({
        variables: {
          order_id: id,
          type: 'DEPOSIT',
          ref_code: formData?.ref_code,
          description: formData?.description,
          amount: !formData.condition ? String(formData.amount) : undefined,
        },
      });
      if (data) {
        data[graph.createTransaction.name]?.messages.map((message) => toast.success(String(message)));
        refetch();
      }
    } catch (error) {}
  };

  return (
    <MuiFormBuilder
      schema={schema()}
      uiSchema={uiSchema()}
      formData={formData}
      onSubmit={onSubmit}
      submit="ایجاد"
      loading={loading}
    />
  );
};

export default RefundToWalletForm;
